import {action, observable} from 'mobx'
import {getDesiveOrderList, getAddOrderList, getOrderDetail, getOrderAddDetail} from '@/services/Order'
import report from '@/utils/log'


class OrderStore {
  @observable selected: number = 0;
  @observable deviceOrder: any[] = [] // 设备订单列表
  @observable addOrder: any[] = [] // 增值订单列表
  @observable orderDetail: any[] = [] // 详情数据

  // 修改展示的订单类型
  @action.bound async changeSelect(index: number) {
      if (this.selected === index) return
      this.selected = index
      if (index === 0) {
        this.getDeviceOrder()
      }
      if (index === 1) {
        this.getAddOrder()
      }
  }
  init() {
    if(this.selected === 0){
       this.getDeviceOrder()
    }
    if(this.selected === 1){
      this.getAddOrder()
    }
  }

  // 获取设备订单列表
  @action.bound async getDeviceOrder() {
      const [error, result] = await getDesiveOrderList()
      if (error) {
        // 订单详情列表获取失败 事件上报
        report({
          eventId: 'E1602',
          pageId: 'P16',
          ext: '',
        })
        return
      }
      console.log(result)

    this.deviceOrder = result.order_list || []

    // 订单详情加载成功 事件上报
    report({
      eventId: 'E1601',
      pageId: 'P16',
      ext: '',
    })

  }

  // 获取增值订单列表
  @action.bound
  async getAddOrder() {
      const [err, result] = await getAddOrderList()
      if (err) {
        // 订单详情列表获取失败 事件上报
        report({
          eventId: 'E1802',
          pageId: 'P18',
          ext: '',
        })
        return;
      }
      console.log(result)
      this.addOrder = result.vas_order_list || []

    // 订单详情列表获取成功 事件上报
    report({
      eventId: 'E1801',
      pageId: 'P18',
      ext: '',
    })
  }

  //设置选择订单类型
  @action.bound setSelected(selected: number) {
      this.selected = selected
  }
   // 获取详情
  @action.bound async getOrderDetail(orderId: number) {

    this.selected === 0 ? this.getOrderDeviceDetail(orderId): this.getOrderAddDetail(orderId)
  }
  // 获取设备订单详情
  @action.bound
  async getOrderDeviceDetail(orderId: number) {
      let params = {
          orderId
      }
      const [err, result] = await getOrderDetail(params)
      if (err) return;
      this.orderDetail = result

    // 获取详情列表成功 事件上报
    report({
      eventId: 'E1700',
      pageId: 'P17',
      ext: '',
    })
  }

  // 获取增值订单详情
  @action.bound
  async getOrderAddDetail(orderId: number){
    let params = {
      orderId
    }
    const [err, result] = await getOrderAddDetail(params)
    if (err) return;
    this.orderDetail = (result && result[0]) ? result : [];
    // 获取详情列表成功 事件上报
    report({
      eventId: 'E1900',
      pageId: 'P19',
      ext: '',
    })
  }

}

export default OrderStore
